import Image from "next/image";
import type { CSSProperties } from "react";

type LogoMarkProps = {
  className?: string;
  style?: CSSProperties;
  title?: string;
};

export function LogoMark({
  className = "h-8 w-8",
  style,
  title = "SenseCollect",
}: LogoMarkProps) {
  return (
    <Image
      alt={`${title} logo`}
      className={className}
      height={64}
      src="/logo-mark.svg"
      style={style}
      unoptimized
      width={64}
    />
  );
}
